
import { defineComponent } from 'vue-demi';
const name = 'creation-footer';

export default defineComponent({
  name,
  components: {},
  props: {
    content: {
      type: String,
      default: 'Next',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    return {};
  },
});
